import React from 'react';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from 'lodash';
import CustomSelect from "../../components/General/CustomSelect";
import CustomInput from "../../components/General/CustomInput";

const columns = [
    { id: 'actions', label: 'actions', width: 10, align: 'center' },
    { id: 'numdoc', label: 'numdoc', width: 20, align: 'center' },
    { id: 'trabajador', label: 'trabajador', width: 150 },
];

const BodyWorkersAdd = ({ data, setData, zonaAfectada }) => {

    const handleRemoveWorkers = (idx, info) => {
        let updData = _.cloneDeep(data);
        updData = updData?.filter(e => e.numdoc !== info.numdoc);
        setData(updData);
    };

    const updateWorkerField = (numdoc, field, value) => {
        const newData = data.map(w =>
            w.numdoc === numdoc ? { ...w, [field]: value } : w
        );
        setData(newData);
    };

    const handleImageChange = (e, row) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onloadend = () => {
            // Igual que en Accidentes
            const imagenEvidencia = {
                file,
                img: reader.result, // BASE64
                name: file.name,
            };

            updateWorkerField(row.numdoc, "imagen", file);
            updateWorkerField(row.numdoc, "imagenPreview", reader.result);
            updateWorkerField(row.numdoc, "imagenEvidencia", imagenEvidencia);
        };

        reader.readAsDataURL(file);
    };

    return (
        <div className="table-responsive">
            <table className="table table-bordered">
                <tbody>

                    {data?.map((row, idxRow) => (
                        <tr key={`row-${idxRow}`}>

                            {/* ====== COLUMNAS INICIALES ====== */}
                            {columns?.map((col) => {
                                const value = row[col.id];
                                return (
                                    <td
                                        key={`col-${col.id}`}
                                        className={`${col.align}`}
                                        style={{
                                            width: `${col.width}px`,
                                            backgroundColor: 'transparent',
                                            borderLeft: 'none',
                                            borderRight: 'none',
                                        }}
                                    >
                                        {col.id === "actions" ? (
                                            <IconButton
                                                aria-label="delete"
                                                size="small"
                                                title="Retirar trabajador"
                                                onClick={() => handleRemoveWorkers(idxRow, row)}
                                                style={{
                                                    border: 'solid 1px',
                                                    borderRadius: '5px',
                                                    padding: '1px',
                                                }}
                                                color='error'
                                            >
                                                <DeleteIcon className="icon-button-table" color={'error'} />
                                            </IconButton>
                                        ) : value}
                                    </td>
                                );
                            })}

                            {/* CAMPOS PARA AFECTADOS */}
                            {row.tipoInvolucrado_id === 1 && (
                                <>
                                    <td style={{ width: "150px", backgroundColor: 'transparent' }}>
                                        <CustomSelect
                                            title="Zona afectada"
                                            value={row.zonaAfectada_id || ""}
                                            onChange={(value) =>
                                                updateWorkerField(row.numdoc, "zonaAfectada_id", value)
                                            }
                                            options={zonaAfectada?.map(z => ({
                                                value: z.id_zonaAfectada,
                                                label: z.desZona
                                            }))}
                                        />
                                    </td>

                                    <td style={{ width: "150px", backgroundColor: 'transparent' }}>
                                        <CustomInput
                                            title="Parte afectada"
                                            value={row.parteAfectada || ""}
                                            onChange={(e) =>
                                                updateWorkerField(row.numdoc, "parteAfectada", e.target.value)
                                            }
                                        />
                                    </td>

                                    <td style={{ width: "150px", backgroundColor: 'transparent' }}>
                                        <CustomInput
                                            title="Inicio DM"
                                            type="date"
                                            value={row.idm || ""}
                                            onChange={(e) =>
                                                updateWorkerField(row.numdoc, "idm", e.target.value)
                                            }
                                        />
                                    </td>

                                    <td style={{ width: "150px", backgroundColor: 'transparent' }}>
                                        <CustomInput
                                            title="Fin DM"
                                            type="date"
                                            value={row.fdm || ""}
                                            onChange={(e) =>
                                                updateWorkerField(row.numdoc, "fdm", e.target.value)
                                            }
                                        />
                                    </td>

                                    <td style={{ width: "150px", backgroundColor: 'transparent' }}>
                                        <CustomInput
                                            title="Alta"
                                            type="date"
                                            value={row.fechaAlta || ""}
                                            onChange={(e) =>
                                                updateWorkerField(row.numdoc, "fechaAlta", e.target.value)
                                            }
                                        />
                                    </td>

                                    <td style={{ width: "100px", backgroundColor: 'transparent' }}>
                                        <CustomSelect
                                            title="Sexo"
                                            value={row.sexo || ""}
                                            onChange={(value) =>
                                                updateWorkerField(row.numdoc, "sexo", value)
                                            }
                                            options={[
                                                { value: "M", label: "Masculino" },
                                                { value: "F", label: "Femenino" }
                                            ]}
                                        />
                                    </td>
                                </>
                            )}

                            {/* =========================================== */}
                            {/* IMAGEN PARA SUPERVISORES (2) & TESTIGOS (3) */}
                            {/* =========================================== */}
                            {(row.tipoInvolucrado_id === 2 || row.tipoInvolucrado_id === 3) && (
                                <td style={{ width: "250px", backgroundColor: 'transparent' }}>

                                    {/* INPUT OCULTO */}
                                    <input
                                        id={`fileInput-${row.numdoc}`}
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, row)}
                                        style={{ display: 'none' }}
                                    />

                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                        {/* BOTÓN */}
                                        <button
                                            className="btn btn-sm btn-outline-primary"
                                            type="button"
                                            onClick={() =>
                                                document.getElementById(`fileInput-${row.numdoc}`).click()
                                            }
                                            title="Subir imagen"
                                        >
                                            Subir imagen
                                        </button>

                                        {/* PREVIEW */}
                                        {row.imagenEvidencia && (
                                            <>
                                                <img
                                                    src={row.imagenEvidencia.img}
                                                    alt="preview"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        objectFit: "cover",
                                                        borderRadius: "5px",
                                                        border: "1px solid #ccc"
                                                    }}
                                                />

                                                {/* Nombre del archivo */}
                                                <span style={{ fontSize: "12px", color: "#555" }}>
                                                    {row.imagenEvidencia?.name}
                                                </span>
                                            </>
                                        )}
                                    </div>

                                </td>
                            )}


                        </tr>
                    ))}

                </tbody>
            </table>
        </div>
    );
};

export default BodyWorkersAdd;
